import axios from "axios";

const kioskBaseUrl = 'http://localhost:9094';

export async function checkCameraStatus() {
    const response = await fetch(`${kioskBaseUrl}/api/hardware/camera/get-status`,);
    return response.json();
}

export async function checkFingerprintStatus() {
    const response = await fetch(`${kioskBaseUrl}/api/hardware/fingerprint-scanner/get-status`,);
    return response.json();
}

export async function deleteBiometric(userId) {
    const response = await axios.delete(`${process.env.REACT_APP_LMS_APP_BASE_URL2}/fingerprints/users/${userId}`, {
        headers: {
            "Content-Type": "application/json",
            token: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
        },
    });
    return response;
}

export async function deleteBiometric2(userId, selectedBiometricType) {
    const response = await axios.delete(
        `${process.env.REACT_APP_PORTAL_APP_BASE_URL}/biometric/${userId}`, {
        data: {
            type: selectedBiometricType,
        },
        headers: {
            "Content-Type": "application/json",
            token: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
        },
    });
    return response;
}

// export async function captureFace(transactionId) {
//     const response = await fetch(`${kioskBaseUrl}/api/hardware/camera/capture`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             Accept: 'application/json',
//         },
//         body: JSON.stringify({ transaction_id: transactionId }),
//     });
//     return response.json();
// }

export async function captureFace(transactionId) {
    try {
        const response = await axios.post(`${kioskBaseUrl}/api/hardware/camera/capture`,
            { transaction_id: transactionId },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Face capture error:', error);
        throw error;
    }
}

export async function scanFingerprint() {
    const response = await fetch(`${kioskBaseUrl}/api/hardware/fingerprint-scanner/scan`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({}),
    },);
    return response.json();
}

export async function registerBiometric(userId, type, imageSrc, dir) {
    const response = await axios.post(`${process.env.REACT_APP_PORTAL_APP_BASE_URL}/biometric/register`, {
        user_id: userId,
        rawData: imageSrc,
        type,
        source: 'KIOSK',
        position: dir,
    }, {
        headers: {
            "Content-Type": "application/json",
            token: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
        },
    });
    return response.data;
}

export async function registerFingerprintBiometric(userId, arr) {    
    const formData = new FormData();
    formData.append('user_id', userId);
    formData.append('kiosk_responses', JSON.stringify(arr));
    const response = await axios.post(`${process.env.REACT_APP_LMS_APP_BASE_URL2}/fingerprints/register`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            token: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
        },
    });
    return response.data;
}

export async function getUserBiometrics(userId) {
    const response = await axios.get(`${process.env.REACT_APP_LMS_APP_BASE_URL2}/fingerprints/users/${userId}`, {
        headers: {
            "Content-Type": "application/json",
            token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
        },
    });
    return response.data;
}

export async function getUserBiometrics2(userId) {
    const response = await axios.get(`${process.env.REACT_APP_PORTAL_APP_BASE_URL}/biometric/${userId}`, {
        headers: {
            "Content-Type": "application/json",
            token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
        },
    });
    return response.data;
}